// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1XRiL","label":"Labeled_label__ycExi","divider":"Labeled_divider__1TORz"};